import React, { useState, useEffect } from 'react';
import { HashRouter as Router, Routes, Route } from 'react-router-dom';
import Header from './components/Header';
import Sidebar from './components/Sidebar';
import Dashboard from './pages/Dashboard';
import Pipeline from './pages/Pipeline';
import Analytics from './pages/Analytics';
import DealModal from './components/DealModal';
import QuotaModal from './components/QuotaModal';
import AuthLayout from './components/AuthLayout';
import { DealsProvider } from './context/DealsContext';
import { QuotaProvider } from './context/QuotaContext';
import { ThemeProvider } from './context/ThemeContext';
import { AuthProvider, useAuth } from './context/AuthContext';
import './App.css';

const AppContent = () => {
  const { isAuthenticated, loading } = useAuth();
  const [sidebarOpen, setSidebarOpen] = useState(false);
  const [showAddModal, setShowAddModal] = useState(false);
  const [showQuotaModal, setShowQuotaModal] = useState(false);

  // Close sidebar when clicking on the main content area on mobile
  const handleMainClick = () => {
    if (sidebarOpen && window.innerWidth < 1024) {
      setSidebarOpen(false);
    }
  };

  // Show loading spinner while checking authentication
  if (loading) {
    return (
      <div className="min-h-screen bg-gray-50 dark:bg-gray-900 flex items-center justify-center">
        <div className="animate-spin rounded-full h-32 w-32 border-b-2 border-blue-600"></div>
      </div>
    );
  }

  // Show auth layout if not authenticated
  if (!isAuthenticated) {
    return <AuthLayout />;
  }

  // Show main app if authenticated
  return (
    <Router>
      <div className="min-h-screen bg-gray-50 dark:bg-gray-900 transition-colors duration-200">
        <Header
          onMenuClick={() => setSidebarOpen(!sidebarOpen)}
          onAddDeal={() => setShowAddModal(true)}
          onSetQuota={() => setShowQuotaModal(true)}
        />
        
        <div className="flex">
          <Sidebar
            isOpen={sidebarOpen}
            onClose={() => setSidebarOpen(false)}
            onSetQuota={() => setShowQuotaModal(true)}
          />
          
          <main
            className="flex-1 transition-all duration-300 lg:ml-64"
            onClick={handleMainClick}
          >
            <div className="p-4 sm:p-6">
              <Routes>
                <Route path="/" element={<Dashboard />} />
                <Route path="/pipeline" element={<Pipeline />} />
                <Route path="/analytics" element={<Analytics />} />
              </Routes>
            </div>
          </main>
        </div>

        {showAddModal && (
          <DealModal onClose={() => setShowAddModal(false)} />
        )}

        {showQuotaModal && (
          <QuotaModal onClose={() => setShowQuotaModal(false)} />
        )}
      </div>
    </Router>
  );
};

function App() {
  return (
    <ThemeProvider>
      <AuthProvider>
        <DealsProvider>
          <QuotaProvider>
            <AppContent />
          </QuotaProvider>
        </DealsProvider>
      </AuthProvider>
    </ThemeProvider>
  );
}

export default App;